/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import {
    HalloweenSpooktacularLowerLeftGraphic, HalloweenSpooktacularLowerRightGraphic,
    HalloweenSpooktacularUpperLeftGraphic, HalloweenSpooktacularUpperRightGraphic
} from '../images';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

export const SpooktacularBackground = () : JSX.Element => (
    <div className={ 'absolute inset-0' }>
        <img
            src={ HalloweenSpooktacularUpperLeftGraphic }
            className={
                clsx(
                    'absolute',
                    'top-0 left-0',
                    'w-auto'
                )
            } />
        <img
            src={ HalloweenSpooktacularUpperRightGraphic }
            className={
                clsx(
                    'absolute',
                    'top-0 right-0',
                    'w-auto'
                )
            } />
        <img
            src={ HalloweenSpooktacularLowerLeftGraphic }
            className={
                clsx(
                    'absolute',
                    'bottom-0 left-0',
                    'w-auto'
                )
            } />
        <img
            src={ HalloweenSpooktacularLowerRightGraphic }
            className={
                clsx(
                    'absolute',
                    'bottom-0 right-0',
                    'w-auto'
                )
            } />
    </div>
);
